'use client';

import { P } from 'components/ring-air-landing/StyleConstants';
import { useTranslations } from 'next-intl';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { CustomImage } from '../custom-image';
import {
  InfoModalContainer,
  InfoModalDescription,
  InfoModalTitle,
} from './layout';
import styles from './TravelChargerModal.module.css';

const useFeatures = () => {
  const t = useTranslations('ring');
  return [
    {
      image: 'web_v2/ring-buy/travel-charger/features/1.1.png',
      mobile: 'web_v2/ring-buy/travel-charger/features/2-mobile.png',
      description: t('ring.infoModals.voyager.features.a'),
    },
    {
      image: 'web_v2/ring-buy/travel-charger/features/2.1.png',
      mobile: 'web_v2/ring-buy/travel-charger/features/1-mobile.png',
      description: t('ring.infoModals.voyager.features.b'),
    },
    {
      image: 'web_v2/ring-buy/travel-charger/features/3.1.png',
      mobile: 'web_v2/ring-buy/travel-charger/features/4-mobile.png',
      description: t('ring.infoModals.voyager.features.c'),
    },
    {
      image: 'web_v2/ring-buy/travel-charger/features/4.1.png',
      mobile: 'web_v2/ring-buy/travel-charger/features/3-mobile.png',
      description: t('ring.infoModals.voyager.features.d'),
    },
  ];
};

const Features = () => {
  const { width } = useWindowSize();
  const features = useFeatures();

  return (
    <div className={styles.features}>
      {features.map((feature, index) => (
        <div className={styles.feature} key={`charger-feature-${index}`}>
          <P>
            {index + 1}. {feature.description}
          </P>
          <div className={styles.imgWrapper}>
            <CustomImage
              src={width > 786 ? feature.image : feature.mobile}
              alt={`feature-${index}`}
              fill
              objectFit="cover"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export const TravelChargerCartInfoModal = () => {
  const t = useTranslations('ring');
  return (
    <InfoModalContainer>
      <InfoModalTitle>
        <h3>{t('ring.infoModals.voyager.title')}</h3>
      </InfoModalTitle>
      <InfoModalDescription>
        <Features />
      </InfoModalDescription>
    </InfoModalContainer>
  );
};

export const TravelChargerPricingModal = ({
  className,
}: {
  className?: string;
}) => {
  const t = useTranslations('ring');
  const { width } = useWindowSize();
  const features = useFeatures();
  return (
    <div
      className={
        className ? `${styles.pricingModal} ${className}` : styles.pricingModal
      }
    >
      <h3>{t('ring.infoModals.voyager.title')}</h3>
      <div className={styles.featuresGroup}>
        {features.map((feature, index) => (
          <div className={styles.feature} key={`charger-feature-${index}`}>
            <P>
              {index + 1}. {feature.description}
            </P>
            <div className={styles.imgWrapper}>
              <CustomImage
                src={width > 786 ? feature.image : feature.mobile}
                alt={`feature-${index}`}
                fill
                objectFit="cover"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
